const removeEmptyRows = list =>
  list.filter(item => item.node.data.title && item.node.data.title.length > 0);

export default removeEmptyRows;
